module.exports = __webpack_public_path__ + "static/media/call-back.b709d954.svg";